import { Button } from '@/components';
import { ButtonStyleVariant } from '@/components/Button/styles';
import { ReactNode } from 'react';

export type ActionConfig = {
  variant?: ButtonStyleVariant;
  className?: string;
  buttonText: string | ReactNode;
  onClick: () => void;
};

interface RequestActionsProps {
  actions: ActionConfig[];
}

export const RequestActions = ({ actions }: RequestActionsProps) => {
  return (
    <div className="flex justify-center">
      <div className="flex gap-2.5">
        {actions.map((action, index) => (
          <Button
            key={index}
            variant={action.variant}
            className={action.className}
            onClick={action.onClick}
          >
            {action.buttonText}
          </Button>
        ))}
      </div>
    </div>
  );
};
